module.exports = __webpack_public_path__ + "static/media/leafModifiedSpine.56bb2c63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/leafModifiedSpine.jpg
// module id = 340
// module chunks = 0